import { render, staticRenderFns } from "./LabelExistingMatches.vue?vue&type=template&id=032057b2"
import script from "./LabelExistingMatches.vue?vue&type=script&lang=js"
export * from "./LabelExistingMatches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports